import React, { useState, useEffect } from "react";
import {Component} from "react";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import "../components/styles/UploadPdf.css";
import axios from "axios";
import { toast } from "react-toastify";

const UploadPdf = () => {
  const [selectedFile, setselectedFile] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [isFilePicked, setIsFilePicked] = useState(false);

  const onFileChange = event => {
    console.log(event.target.files[0]);
    // Update the state
    //setState({ selectedFile: event.target.files[0] });
    setselectedFile(event.target.files[0]);
    setIsFilePicked(true);
    console.log('Inside onFileChange', selectedFile);
    };

  const testAxios = async (data)=> {
    axios
    .post(
      "https://tokcfhkksh.execute-api.us-east-1.amazonaws.com/Dev/vcare_faxupload",
      data
    )
    .then((response) => { 
      console.log(response);
      let isStatus = response.data.headers.success;
      console.log(isStatus);
      if (isStatus === true) { 
        toast.success(response.data.body, { autoClose: false });
      } else {
        toast.error(response.data.body, { autoClose: false });
        setOpen(true);
      }
     })
     .catch((error) => { 
      console.log(error);
     })
  };

  const onFileUpload = file => {
    return new Promise(resolve => {
      let fileInfo;
      let reader = new FileReader();
      let res = "default";
      const date = new Date();
      const today_date = _formatTheDate(date);
      // Convert the file to base64 text
      reader.readAsDataURL(selectedFile);
      // on reader load something
      reader.onload = () => {
        // Make a fileInfo Object
        console.log("Called", reader);
        console.log(reader.result);
        res = reader.result;
        let res1 = res.split(',')[1];
        console.log('result ', res1);
        //setb64(res);
        //console.log(baseURL);
        testAxios({fax_data: res1, file: selectedFile.name, date: today_date});
        //resolve(baseURL);
      };
      console.log(fileInfo);
    });
  };

  const _formatTheDate = dateParam => {
    const yyyy = dateParam.getFullYear();
    let mm = dateParam.getMonth() + 1; // Months start at 0!
    let dd = dateParam.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const formattedDate = mm + "-" + dd + "-" + yyyy;
    return formattedDate;
  };

  return (
    <>
      <Box className="uploadPdf-container">
        <Typography variant="h4">Upload PDF</Typography>
        <Button variant="outlined" component="label">
        <input type="file" hidden onChange={onFileChange} /> 
        {isFilePicked ? (
				<div>
					<p>File selected: {selectedFile.name}</p>
				</div>
			) : (
				<p>Select a file to upload</p>
			)}
        </Button>
        <Button variant="contained" onClick={onFileUpload}>
        Upload!
				</Button>
      </Box>
    </>
  );
};

export default UploadPdf;
